var a={categoryLabel:"categoryLabel__Yx27ly"};export{a as default};
